export default __webpack_public_path__ + "static/media/theme-home.45a0de06.svg";